import MsgTargetConfig from './MsgTargetConfig';
import './style/index.less';

export default MsgTargetConfig;
